import React, {useEffect, useState} from "react";

type Props = {
    curAccount: any;
    index: number;
    name: any;
    setName: (val: any) => void;
    editable: boolean;
    setIsSavedResult: any;
    setCertificate: any;
};

export const AssessmentYearRow = ({
                                      curAccount,
                                      index,
                                      name,
                                      setName,
                                      editable,
                                      setIsSavedResult,
                                      setCertificate,
                                  }: Props) => {
    const [localTaxYear, setLocalTaxYear] = useState<string>("");

    useEffect(() => {
        const year = curAccount?.assessments?.[index]?.taxYear;
        setLocalTaxYear(year?.toString() || "");
    }, [curAccount?.assessments?.[index]?.taxYear]);

    const handleChange = (raw: string) => {
        const numeric = raw.replace(/\D/g, "").slice(0, 4);
        setLocalTaxYear(numeric);

        const parsed = parseInt(numeric) || "";

        setCertificate((prev:any) => {
            const certAccounts = [...prev.accounts];
            const accountIndex = certAccounts.indexOf(curAccount);

            if (accountIndex === -1) return prev;

            const updatedAccount = { ...certAccounts[accountIndex] };
            const updatedAssessments = [...(updatedAccount.assessments || [])];

            if (!updatedAssessments[index]) return prev;

            updatedAssessments[index] = {
                ...updatedAssessments[index],
                taxYear: parsed,
            };

            updatedAccount.assessments = updatedAssessments;
            updatedAccount.taxDataSource = "EDITOR";
            updatedAccount.asOfDate = new Date();

            certAccounts[accountIndex] = updatedAccount;

            return {
                ...prev,
                accounts: certAccounts,
            };
        });

        setIsSavedResult(false);
        setName(name);
    };

    return (
        <input
            className="text-surface-3 pl-2 pr-2 rounded w-20 bg-surface-5"
            name="taxYear"
            id={`taxYear-${index}`}
            type="text"
            autoComplete="off"
            placeholder="Select Year..."
            value={localTaxYear}
            onChange={(e) => handleChange(e.target.value)}
            readOnly={!editable}
        />
    );
};
